
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/produtos/squad-ia",
      function () {
        return require("private-next-pages/[locale]/produtos/squad-ia.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/produtos/squad-ia"])
      });
    }
  